import React from "react";

export const EngineModeling = () => {

    return(
        <>
        <iframe style={{width : '100%', height : '1190px'}} src={'https://alink3d.com/ModelingCtrl/modeling_view_D976_MARINE_PROJECT2.html'}></iframe>
        </>
    )
}